module.exports = __webpack_public_path__ + "static/media/check.beed81d7.svg";